export default __webpack_public_path__ + "static/media/metamask.7edf7204.svg";